import core, { App } from '@gin-betting/core';

const {
    utils: { isOneOfPages },
} = core;

export default function checkIsDynamicCategorizer(): boolean {
    return isOneOfPages(
        [
            App.Routes.OUTRIGHTS_LIST,
            App.Routes.OUTRIGHT,
            App.Routes.RESULTS_LIST,
        ],
        {
            exact: true,
        }
    );
}
